import { render, staticRenderFns } from "./privacy2.0.vue?vue&type=template&id=11ab2284&scoped=true&"
import script from "./privacy2.0.vue?vue&type=script&lang=js&"
export * from "./privacy2.0.vue?vue&type=script&lang=js&"
import style0 from "./privacy2.0.vue?vue&type=style&index=0&id=11ab2284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ab2284",
  null
  
)

export default component.exports